import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/relations/entities-to-logs/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ENTITIES_TO_LOGS }) &&
      context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
